import ReportList from "components/reports/ReportList";
import * as React from 'react';
export default {
  ReportList,
  React
};